import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MainModules } from 'common/constants/features';

import { IDayReportCategoryWiseFields, IRoyaltyConfig, UIError } from 'common/interfaces';
import { IBrand } from 'common/interfaces/ibrand';
import { IRoleAccess } from 'common/interfaces/irole';
import { ISessionState } from 'common/interfaces/isession';
import { IUserShift } from 'common/interfaces/ishift';
import { IStore } from 'common/interfaces/istore';
import UILogger from 'common/utils/logger';

const initialAppState: ISessionState = {
  selectedBrand: undefined,
  selectedStore: undefined,
  selectedShift: undefined,
  accessList: undefined,
  allowedFeatures: undefined,
  loading: false,
  error: undefined,
  dayReportCategoryWiseFields: undefined,
  royaltyConfig: undefined,
};

const reducers = {
  setLoading: (state: ISessionState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: ISessionState, action: PayloadAction<UIError>) => {
    state.error = action.payload;
  },
  resetState: (state: ISessionState) => {
    state.selectedBrand = undefined;
    state.selectedStore = undefined;
    state.selectedShift = undefined;
    state.error = undefined;
    state.loading = false;
  },
  setSelectedBrand: (state: ISessionState, action: PayloadAction<IBrand | undefined>) => {
    state.selectedBrand = action.payload;
  },
  setSelectedStore: (state: ISessionState, action: PayloadAction<IStore | undefined>) => {
    state.selectedStore = action.payload;
  },
  setSelectedShift: (state: ISessionState, action: PayloadAction<IUserShift | undefined>) => {
    state.selectedShift = action.payload;
  },
  setAllowedFeatures: (state: ISessionState, action: PayloadAction<MainModules[] | undefined>) => {
    state.allowedFeatures = action.payload;
  },
  setAccessList: (state: ISessionState, action: PayloadAction<IRoleAccess[] | undefined>) => {
    state.accessList = action.payload;
  },
  setDayReportFields: (state: ISessionState, action: PayloadAction<IDayReportCategoryWiseFields | undefined>) => {
    state.dayReportCategoryWiseFields = action.payload;
    UILogger.log('session-reducer: updated day report fields:', state.dayReportCategoryWiseFields);
  },
  setRoyaltyConfig: (state: ISessionState, action: PayloadAction<IRoyaltyConfig | undefined>) => {
    state.royaltyConfig = action.payload;
  },
};

const sessionSlice = createSlice({
  name: 'ISessionState',
  initialState: initialAppState,
  reducers: reducers,
});

export default sessionSlice.reducer;
export const SessionActions = sessionSlice.actions;
